import type { FaireProductEntity } from "../../entity_types/product";

export const p_q868yjffpu: FaireProductEntity = {
  token: "p_q868yjffpu",
  type: "product",
  name: "Sparkling Butterfly Rhinestone Gold-Dipped Stud Earrings",
  brandToken: "b_k2cxrcr92s",
  brandName: "Frem",
  imageUrl:
    "https://cdn.faire.com/fastly/1e66b023d95c046f9f88275175f26d35f8ec9a79c94eb7b8b32d6fbc35bbd8c6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c83481c626a5712dd37c313f92282b949d2fdba5f96a1fef103d7c8927865d7f.jpeg",
    "https://cdn.faire.com/fastly/4b2ea416581018093f0eab3ab9a6196e353ff549d1cfb1495c95ab7297f52664.jpeg",
    "https://cdn.faire.com/fastly/1405e778a94238a848c7803ed2037f5c799bfc23f95e5f8800dc193ea45512ba.jpeg",
  ],
  priceDollars: 15.94,
  description:
    "Butterfly Rhinestones Gold Dip Stud Earrings\n\nAdd a touch of elegance and sparkle to your look with our Butterfly Rhinestones Gold Dip Stud Earrings. Featuring a delicate butterfly design adorned with shimmering rhinestones and finished with a luxurious gold dip, these earrings are perfect for any occasion. Make a statement and elevate your style with this exquisite accessory.\n\nApproximate size: 55 mm\n",
  tags: [],
  msrpDollars: 47.81,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:39.768Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
